var map = {
	"./icon-dapp-aave.svg": "8852",
	"./icon-dapp-coinbase.svg": "29c2",
	"./icon-dapp-ensmanager.svg": "3c72",
	"./icon-dapp-ethblocks.svg": "67fb",
	"./icon-dapp-flyover.svg": "c38c",
	"./icon-dapp-rns.svg": "cf68",
	"./icon-dapp-rsk-collective.svg": "30f9",
	"./icon-dapp-stake.svg": "0143",
	"./icon-dapp-stakewise.svg": "787b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54d9";